/*
 * @Author: huxiaohui 826564596@qq.com
 * @Date: 2025-06-30 15:49:20
 * @LastEditors: huxiaohui 826564596@qq.com
 * @LastEditTime: 2025-07-25 15:30:47
 * @FilePath: \client-h5\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */


import "_libs/base";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import VueTouch from "vue-touch";
import "./assets/style/base.less";
import { install } from "./libs/amap.js";
import Vue from "vue";
import importDirective from "@/directive";
// import VConsole from "vconsole";
// new VConsole();

import { appEnv } from '@/libs/env'
const APPENV = appEnv()
store.commit('setAppEnv', APPENV)
if (!localStorage.getItem('userId')) {
    localStorage.setItem('userId', 1)
}
Vue.config.ignoredElements = ["wx-open-launch-weapp"];

Vue.config.productionTip = false;
Vue.use(VueTouch);
importDirective(Vue); //注册指令
install(Vue); //初始化高德地图 将Amap挂载到Vue上


new Vue({
    el: "#app",
    render: (h) => h(App),
    router,
    store,
});
